export default __webpack_public_path__ + "static/media/nico-marks.5a4dd1e3.jpg";